import styled from "styled-components";

type Props = {
  title: string;
  desc?: string | JSX.Element;
  mb?: string;
  smCenter?: boolean;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  titleMb?: string;
  children?: JSX.Element;
  titleClassName?: string;
  actionButton?: JSX.Element;
  noDesc?: boolean;
};

const Title = ({
  title,
  desc,
  mb = "mb-3",
  smCenter,
  variant = "h3",
  titleMb,
  actionButton,
  children,
  titleClassName,
  noDesc,
}: Props) => {
  return (
    <TitleWrapper className={noDesc ? "" : mb} smCenter={smCenter}>
      <div className="d-flex align-items-center">
        <h1
          style={{ lineHeight: 1.6 }}
          className={`text-uppercase text-left ${variant} ${
            titleClassName || ""
          } ${titleMb || "mb-1"}`}
        >
          {title}
        </h1>
        {actionButton ? actionButton : null}
      </div>
      {desc && !noDesc && <p className="fs-md text-muted mb-0">{desc}</p>}
      {children}
    </TitleWrapper>
  );
};

export default Title;
const TitleWrapper = styled.div<{
  smCenter?: boolean;
}>`
  @media (max-width: 991.98px) {
    text-align: ${(props) => (props.smCenter ? "center" : "initial")};
  }
  @media (max-width: 767.98px) {
    h1 {
      font-size: 1rem;
    }
  }
`;
